export const styles = {
  datePickerWrapper: {
    width: '218px',
  },
  resetButtonIcon: {
    marginRight: '4px',
    marginTop: '1px',
  },
};
